// Mobile drawer lazy hydration — pierwszy klik hamburgera:
//   1. Klonuje <template id="mobile-menu-tpl"> do body (wtedy #mobile-menu istnieje)
//   2. Uruchamia initMobileDrawer() (bindingi na close/back/screens)
//   3. Ręcznie otwiera drawer (bo initMobileDrawer bindnął nowy handler na hamburger,
//      ale nasz obecny click event już się rozwinął — musimy manualnie triggerować open).
// Kolejne kliknięcia: hamburger ma już zbindowany handler z initMobileDrawer → normalne open().

let hydrated = false;

function hydrateAndOpen() {
  if (hydrated) return false;
  const tpl = document.getElementById('mobile-menu-tpl');
  if (!tpl || !(tpl instanceof HTMLTemplateElement)) return false;
  document.body.appendChild(tpl.content.cloneNode(true));
  tpl.remove();
  hydrated = true;

  if (typeof window.kbInitMobileDrawer === 'function') {
    window.kbInitMobileDrawer();
  }

  // Manual first-open — bo click event już się rozwinął zanim initMobileDrawer bindł handler.
  const drawer = document.getElementById('mobile-menu');
  if (!drawer) return false;
  const panel    = drawer.querySelector('[data-mm-panel]');
  const backdrop = drawer.querySelector('[data-mm-backdrop]');
  drawer.classList.remove('pointer-events-none');
  drawer.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(() => {
    if (backdrop) backdrop.style.opacity = '1';
    if (panel)    panel.classList.remove('-translate-x-full');
  });
  document.documentElement.style.overflow = 'hidden';
  return true;
}

function bindHamburgerHydrate() {
  const buttons = document.querySelectorAll('[data-mobile-menu-toggle]');
  buttons.forEach((b) => {
    b.addEventListener('click', function firstClick() {
      if (hydrated) return;
      hydrateAndOpen();
    });
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') bindHamburgerHydrate();
  else document.addEventListener('DOMContentLoaded', bindHamburgerHydrate);
}

export {};
